<template>
  <field-layout ref="field" :content="content">
    <national-local-location-selector ref="nationalLocalLocationSelector"
                                      :value="value" :validation-errors="validationErrors"
                                      @changed="updateValue"
                                      @location-kind-changed="locationKindChanged" />
    <hidden-fields :location="value" field-group-name="location" />
  </field-layout>
</template>

<script>
import FieldLayout from './field-layout'
import FieldMixin from '@/campaign-form-shared/field-mixin'
import HiddenFields from '@/components/inputs/locations/hidden-fields'
import NationalLocalLocationSelector from '@/components/inputs/national-local-location-selector'

export default {
  components: { FieldLayout, HiddenFields, NationalLocalLocationSelector },

  mixins: [ FieldMixin ],

  methods: {
    focus() {
      this.$refs.nationalLocalLocationSelector.focus()
    },

    locationKindChanged(locationKind) {
      this.$store.commit('setValue', {field: 'locationKind', value: locationKind})
    },

    updateValue(newValue) {
      this.$store.commit('setValue', {field: 'location', value: newValue})
    }
  }
}
</script>

<style lang="scss" scoped>
@use "~common_styles/breakpoints" as breakpoints;

// national-local-location-selector overrides
::v-deep(.form-check) {
  gap: 20px;
  margin-bottom: 30px;
}

::v-deep(.form-check-input) {
  margin-top: 8px;
}

::v-deep(.form-check-label) {
  font-size: 20px;
  display: block;
  margin-left: 20px;
}

::v-deep(input#location-query-field) {
  margin-bottom: 0;
  height: 58px;

  @include breakpoints.screen-mobile-only {
    height: 50px;
  }

}
</style>
